__turbopack_context__.v({
  "image": "ArtikkelBilde-module__k57RmG__image",
  "styledFigure": "ArtikkelBilde-module__k57RmG__styledFigure",
  "zoom": "ArtikkelBilde-module__k57RmG__zoom",
});
